<div class="mdk-drawer-layout__content page">
    <div class="container-fluid page__heading-container">
        <div
            class="page__heading d-flex flex-column flex-md-row align-items-center justify-content-center justify-content-lg-between text-center text-lg-left">
            <h1 class="m-lg-0">Requests</h1>
            <!--
            "listRequests","readRequests","","","importRequests" -->
            <button class="btn btn-primary ml-lg-3 float-right"
                 [routerLink]="['/request/addRequest']"   *ngIf="userService.rolesArrayPermission.includes('addRequests')"><i
                    class="material-icons mr-2">add_circle</i>Add New</button>
        </div>
        <!-- [routerLink]="['/banner/addBanner', data?.id]" -->
    </div>
    <div class="container-fluid">
        <div class="card">
            <div class="card-body">
                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover">
                    <thead>
                        <tr>
                            <th width="50px">#</th>
                            <th width="100">Name</th>
                            <th width="100">Mobile</th>
                            <th width="150">Status</th>
                            <th width="150">Description</th>
                            <th width="150">Comment</th>
                            <th width="100">Request Type</th>

                            <th width="150">Action</th>

                        </tr>
                    </thead>
                    <tbody *ngIf="bannersList && bannersList.length > 0">
                        <tr *ngFor="let banner of bannersList; let index = index">
                            <td>{{index + 1}}</td>
                            <td>{{banner?.name}}</td>
                            <td class="capitalize">{{banner?.mobile}}</td>

                            <td class="capitalize">{{banner?.status?.toLowerCase()}}</td>

                            <td>{{banner?.description}}</td>
                            <td>{{banner?.comment}}</td>
                            <td>{{banner?.request_type}}</td>

                            <td>
                                <button class="btn bg-transparent" *ngIf="userService.rolesArrayPermission.includes('editRequests')"
                                    [routerLink]="['/request/addRequest', banner?.id]">
                                    <a class="edit" title="Edit" data-toggle="tooltip"><i class="material-icons">&#xE254;</i></a>
                                </button>
                                <button class="btn bg-transparent">
                                    <a class="view" title="view" data-toggle="tooltip"
                                        (click)="viewBannerDetails(viewBanners, banner?.id)"><i
                                            class="material-icons">visibility</i></a>
                                </button>

                            </td>

                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<ng-template #viewBanners let-modal>
    <div class="modal-content">
        <div class="modal-body">
            <div class="container emp-profile">
                <form method="post">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="float-right" style="width: 80px;">
                                <input type="submit" *ngIf="userService.rolesArrayPermission.includes('editRequests')"
                                    [routerLink]="['/request/addRequest', viewBanner?.id]" class="profile-edit-btn"
                                    (click)="closeModal()" name="btnAddMore" value="Edit" />
                            </div>
                            
                            <div class="row">
                                <div class="col-md-4"></div>
                                <div *ngIf="fileToReturn" class="mt-2 text-center pointer col-md-4">
                                    <button (click)="uploadBannerImage(viewBanner?.id)">Upload</button>
                                </div>
                                <div class="col-md-4"></div>
                            </div>
                        </div>

                        <div class="col-md-12">
                            
                            <div class="profile-head">
                                <h5>
                                    {{viewBanner?.title}}
                                </h5>
                                <ul class="nav nav-tabs" id="myTab" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home"
                                            role="tab" aria-controls="home" aria-selected="true">About</a>
                                    </li>
                                </ul>
                            </div>
                            <div class="tab-content profile-tab" id="myTabContent">
                                <div class="tab-pane fade show active" id="home" role="tabpanel"
                                    aria-labelledby="home-tab">
                                    <div class="row" *ngIf="viewBanner?.name">
                                        <div class="col-md-4">
                                            <label>Name</label>
                                        </div>
                                        <div class="col-md-8">
                                            <p>{{viewBanner?.name}}</p>
                                        </div>
                                    </div>


                                    <div class="row" *ngIf="viewBanner?.mobile">
                                        <div class="col-md-4">
                                            <label>Mobile</label>
                                        </div>
                                        <div class="col-md-8">
                                            <p>{{viewBanner?.mobile}}</p>
                                        </div>
                                    </div>




                                    <div class="row" *ngIf="viewBanner?.status">
                                        <div class="col-md-4">
                                            <label>Status</label>
                                        </div>
                                        <div class="col-md-8">
                                            <p class="capitalize">{{viewBanner?.status?.toLowerCase()}}</p>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="viewBanner?.description">
                                        <div class="col-md-4">
                                            <label>Description</label>
                                        </div>
                                        <div class="col-md-8">
                                            <p>{{viewBanner?.description}}</p>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="viewBanner?.old_mobile">
                                        <div class="col-md-4">
                                            <label>Old Mobile</label>
                                        </div>
                                        <div class="col-md-8">
                                            <p>{{viewBanner?.old_mobile}}</p>
                                        </div>
                                    </div>

                                    <div class="row" *ngIf="viewBanner?.nominee?.name">
                                        <div class="col-md-4">
                                            <label>Nominee Name</label>
                                        </div>
                                        <div class="col-md-8">
                                            <p class="capitalize">{{viewBanner?.nominee?.name}}</p>
                                        </div>
                                    </div>

                                    <div class="row" *ngIf="viewBanner?.nominee?.mobile">
                                        <div class="col-md-4">
                                            <label>Nominee Mobile</label>
                                        </div>
                                        <div class="col-md-8">
                                            <p class="capitalize">{{viewBanner?.nominee?.mobile}}</p>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="viewBanner?.nominee?.relation">
                                        <div class="col-md-4">
                                            <label>Relation With</label>
                                        </div>
                                        <div class="col-md-8">
                                            <p class="capitalize">{{viewBanner?.nominee?.relation}}</p>
                                        </div>
                                    </div>

                                    <div class="row" *ngIf="viewBanner?.nominee?.percent">
                                        <div class="col-md-4">
                                            <label>Percent</label>
                                        </div>
                                        <div class="col-md-8">
                                            <p class="capitalize">{{viewBanner?.nominee?.percent}}%</p>
                                        </div>
                                    </div>

                                    <div class="row" *ngIf="viewBanner?.nominee?.address1">
                                        <div class="col-md-4">
                                            <label>Nominee Address</label>
                                        </div>
                                        <div class="col-md-8">
                                            <p class="capitalize">{{viewBanner?.nominee?.address1}}</p>
                                        </div>
                                    </div>

                                    <div class="row" *ngIf="viewBanner?.nominee?.address2">
                                        <div class="col-md-4">
                                            <label>Nominee address2</label>
                                        </div>
                                        <div class="col-md-8">
                                            <p class="capitalize">{{viewBanner?.nominee?.address2}}</p>
                                        </div>
                                    </div>

                                    <div class="row" *ngIf="viewBanner?.nominee?.minor_name">
                                        <div class="col-md-4">
                                            <label>Nominee Minor Name</label>
                                        </div>
                                        <div class="col-md-8">
                                            <p class="capitalize">{{viewBanner?.nominee?.minor_name}}</p>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="viewBanner?.request_type">
                                        <div class="col-md-4">
                                            <label>Request Type</label>
                                        </div>
                                        <div class="col-md-8">
                                            <p>{{viewBanner?.request_type}}</p>
                                        </div>
                                    </div>
                                    <!-- <div class="row" *ngIf="viewBanner?.end_date">
                                        <div class="col-md-4">
                                            <label>End Date</label>
                                        </div>
                                        <div class="col-md-8">
                                            <p>{{viewBanner?.end_date}}</p>
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="card-footer">
                <button (click)="closeModal()" class="btn btn-primary float-right">OK</button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #cropeImage let-close="close">
    <div class="modal-header">
        <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="4 / 2"
            (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady($event)"
            (loadImageFailed)="loadImageFailed()"></image-cropper>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary"
            (click)="close(); resetSelectedImage(fileInput)">Cancel</button>
        <button type="button" class="btn btn-outline-secondary" (click)="close()">Confirm</button>
    </div>
</ng-template>
